import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { TracedRoutes } from '@comeon/error-reporter';
import { ROUTE_CAMPAIGN_REGISTER, ROUTE_LIVE_CASINO_GAME, ROUTE_CASINO_GAME } from '~/components/router/constants.js';
import Header from '~/components/header/header.js';
import IngameDesktopHeader from '~/components/header/ingame-desktop-header/index.js';
import { selectIsDesktop } from '~/components/brand/ducks/selectors.js';
import Burger from '~/components/header/burger.js';
import RightContainerHeader from '~/components/header/right-container-header.js';

const RoutesHeader = () => {
	const isDesktop = useSelector(selectIsDesktop);
	const PATHS_WITH_INGAME_HEADER = useMemo(() => {
		return [...(isDesktop ? [ROUTE_LIVE_CASINO_GAME, ROUTE_CASINO_GAME] : [])];
	}, [isDesktop]);
	return (
		<TracedRoutes>
			<Route path="/" exact />
			<Route path={ROUTE_CAMPAIGN_REGISTER} />
			{PATHS_WITH_INGAME_HEADER.map(path => (
				<Route
					path={`${path}/*`}
					key={path}
					element={<IngameDesktopHeader RightContainerHeader={RightContainerHeader} isInGame="true" />}
				/>
			))}
			<Route
				path="*"
				element={
					<Header Burger={Burger}>
						<RightContainerHeader />
					</Header>
				}
			/>
		</TracedRoutes>
	);
};

export default RoutesHeader;
